//this localStorage has these data
//isFirsttime

import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private localStorageKey = environment.apiBaseUrl + '-rootScope';
  loginErrorMessage:string;
  constructor() { }

  getSharedData(): any {
    const dataString = localStorage.getItem(this.localStorageKey);
    return dataString ? JSON.parse(dataString) : {};
  }

  getLoginPageErrMsg() {
    return this.loginErrorMessage;
  }

  setSharedData(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  setBulkDataWithExistingData(newData: any) {
    const existingData = this.getSharedData();
    const mergedData = { ...existingData, ...newData }; // Merge existing data with new data
    localStorage.setItem(this.localStorageKey, JSON.stringify(mergedData));
  }

  getValue(key: string): any {
    const data = this.getSharedData();
    return data[key];
  }

  setValue(key: string, value: any) {
    const data = this.getSharedData();
    data[key] = value;
    this.setSharedData(data);
  }

  clearSharedData() {
    localStorage.removeItem(this.localStorageKey);
  }
   removeParticularItem(key: string) {
    const data = this.getSharedData();
    if (data.hasOwnProperty(key)) {
      delete data[key];
      localStorage.removeItem(key);
    }
    this.setSharedData(data);
  }
}

/* Available Key
    * applicationId
    * checkoutId
    * productId
    * isChangeOfService
    * serviceChangeRequestId
    * isDifferentSubCategory


*/

/*

// Retrieve shared data when the component initializes
    this.sharedData = this.sharedDataService.getSharedData();

    // Update the shared data
    updateSharedData() {
    const newData = {
      key1: 'value1',
      key2: 'value2',
      // Add more key-value pairs as needed
    };
    this.sharedDataService.setSharedData(newData);
  }

  //set single value
  this.sharedDataService.setValue('isFirsttime', true);

  //get single value
  const isFirsttimeDDD = this.sharedDataService.getValue('isFirsttime');
*/
